import { createSelector } from 'reselect';
import precise from '../../src/modules/precise';
import countyTaxTotal from './countyTaxTotal.selector';

const floridaSalesTaxSel = state => state.salestaxes.floridaSalesTax;
const countyDiscretionaryTaxSel = state => countyTaxTotal(state);

const selector = createSelector(
  [floridaSalesTaxSel, countyDiscretionaryTaxSel],
  (sales, tax) => {
    return precise(Number(sales) + Number(tax));
  },
);

export default selector;



// WEBPACK FOOTER //
// ./src/selectors/subtotalSalesTax.selector.js